export default {
    name: "Filter A and filter B",
    data:
    {
        "id": "7b254af5-c058-4d65-aa27-3b4d47a8d269",
        "type": "Composite",
        "config": {
            "operator": "Filter",
            "combine_on": "date",
            "right": {
                "id": "98c1fedb-cbeb-40b7-97cb-8f085deb3785",
                "title": "Filter A and filter B",
                "type": "Composite",
                "config": {
                    "operator": "Filter",
                    "combine_on": "date",
                    "left": {
                        "id": "0dfc1797-6d00-4f45-93e3-3f1e9f67d0eb",
                        "title": "Filter A",
                        "type": "Composite",
                        "config": {
                            "operator": "LessThan",
                            "combine_on": "date",
                            "left": {
                                "id": "50f96c93-b13f-46ac-ac55-2efab72838e5",
                                "type": "Single",
                                "config": {
                                    "type_id": "linepack",
                                    "hub_id": 17,
                                    "hour": "9",
                                    "start_date": "2025-06-27",
                                    "end_date": "2025-08-26"
                                }
                            },
                            "right": {
                                "id": "e9a9fcae-92f1-44e5-8feb-87ff8ef982b3",
                                "type": "Single",
                                "config": {
                                    "type_id": "constant_value",
                                    "value": 0,
                                    "start_date": "2025-06-27",
                                    "end_date": "2025-08-26"
                                }
                            }
                        }
                    },
                    "right": {
                        "id": "35f1b977-6398-4eb3-8285-c028a04258c2",
                        "title": "Filter B",
                        "type": "Composite",
                        "config": {
                            "operator": "LessThan",
                            "combine_on": "date",
                            "left": {
                                "id": "abb987ac-7dc9-4ad8-bb33-7451e9a4336a",
                                "type": "Single",
                                "config": {
                                    "type_id": "linepack",
                                    "hub_id": 17,
                                    "hour": "12",
                                    "start_date": "2025-06-27",
                                    "end_date": "2025-08-26"
                                }
                            },
                            "right": {
                                "id": "fdf4eff8-a176-46bc-9363-9f95f9a9dacf",
                                "type": "Single",
                                "config": {
                                    "type_id": "constant_value",
                                    "value": 0,
                                    "start_date": "2025-06-27",
                                    "end_date": "2025-08-26"
                                }
                            }
                        }
                    }
                }
            }
        }
    }

}